import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHomeOffersData} from '../../utils/endpoints'
import InnerContent from '../components/innerContent';
import { Container } from 'react-bootstrap';
import Breadcrumb from '../components/breadcrumb';
import Loading from '../components/loading';
import GalleryCard from '../components/galleryCard';
import { Helmet } from 'react-helmet';

const OfferDetails = (props) => {
    const [offersData, setOffersData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const offersData = await getHomeOffersData(id);
            setOffersData(offersData);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
        return <div>Error: {error.message}</div>;
      }

  return (
    <div>
      <Helmet>
      <title>{offersData[0]?.title?.rendered} || Statue of Belief || Worlds tallest shiva Statue</title>
      </Helmet>
      <Container>
        <Breadcrumb pageTitle={offersData[0]?.title?.rendered}/>
        <h1 className="blog-heading">{offersData[0]?.title?.rendered}</h1>
        <InnerContent compData={offersData}/>
        <GalleryCard />
      </Container>
    </div>
  );
};

export default OfferDetails;